export default __webpack_public_path__ + "static/media/p28.82cb3847.jpg";